import { Avatar, Box } from '@mui/material'
import React from 'react'
import BadgeStatus from 'utils/project/status-badge'
import { useStyles } from './styles'

interface IOrganizationHeaderProps {
  corporateName: string
  isInactive: boolean
  logo?: string | null
}

const OrganizationHeader: React.FC<IOrganizationHeaderProps> = ({ corporateName, isInactive, logo }) => {
  const classes = useStyles()

  return (
    <Box className={classes.root}>
      {logo && logo?.length > 0 ? (
        <Avatar
          src={logo as string}
          sx={{ background: '#BDBDBD', width: '2.5rem', height: '2.5rem' }}
        ></Avatar>
      ) : (
        <Avatar sx={{ width: 40, height: 40 }}>{(corporateName || '').charAt(0).toUpperCase()}</Avatar>
      )}

      <h1>{corporateName}</h1>
      <BadgeStatus isInactive={isInactive} />
    </Box>
  )
}

export default OrganizationHeader
